import angular, { ILogService, IQService, ITimeoutService } from 'angular'
import { NotificacionService } from '../../../../_panel/module/uni-base/services/NotifService'
import { IEdicionPregunta, IModelMainQuestion, IModelPregunta, ITipoQ } from '../../../../model/candidato-api'
import { AccesoDatos } from '../../../comun/services/acceso-datos'

import './panel-preguntas.scss'
import { deburr, forEach, lowerCase, mapValues, pickBy, reduce, trim, values } from 'lodash'

type FiltrosBtn = {
  required: boolean
  multiple: boolean
  listado: boolean
  buscar: boolean
  keep_history: boolean
  omit_history_match: boolean
}

type DefTipo = { t: ITipoQ; visible: boolean; pad: string; mask: number }
type DefFlag = { p: Partial<keyof IModelPregunta>; mask: number; pad?: string; t: string; icon: string }

type FiltroFlag = { def: DefFlag; activo: boolean }
type FiltroTipo = { def: DefTipo; activo: boolean }

type Filtros = {
  filterq: string | null
  flags: FiltroFlag[]
  flags_mask: number
  tipo: Record<ITipoQ, FiltroTipo>
  tipo_mask: number
}

export const TIPO_F: Record<ITipoQ, DefTipo> = {
  ROW: { t: 'ROW', visible: true, pad: '                         ', mask: 0b10000000000000 }, //
  SELECT: { t: 'SELECT', visible: true, pad: '                   ', mask: 0b01000000000000 }, //
  TEXT: { t: 'TEXT', visible: true, pad: '                       ', mask: 0b00100000000000 },
  YESNO: { t: 'YESNO', visible: true, pad: '                     ', mask: 0b00010000000000 },
  MEMO: { t: 'MEMO', visible: true, pad: '                       ', mask: 0b00001000000000 },
  FILE: { t: 'FILE', visible: true, pad: '                       ', mask: 0b00000100000000 },
  MULTIPLE: { t: 'MULTIPLE', visible: true, pad: '               ', mask: 0b00000010000000 },
  PARAM: { t: 'PARAM', visible: true, pad: '                     ', mask: 0b00000001000000 },
  PARAM2: { t: 'PARAM2', visible: true, pad: '                   ', mask: 0b00000000100000 },
  DATE: { t: 'DATE', visible: true, pad: '                       ', mask: 0b00000000010000 },
  EMAIL: { t: 'EMAIL', visible: true, pad: '                     ', mask: 0b00000000001000 },
  ERROR: { t: 'ERROR', visible: false, pad: '                    ', mask: 0b00000000000100 },
  NUMBER: { t: 'NUMBER', visible: true, pad: '                   ', mask: 0b00000000000010 },
  PARAMOCULTO: { t: 'PARAMOCULTO', visible: true, pad: '         ', mask: 0b00000000000001 },
}

const FLAGS_MASK_LIST: DefFlag[] = [
  { p: 'required', pad: '           ', mask: 0b100000, t: 'Required', icon: 'star' },
  { p: 'multiple', pad: '           ', mask: 0b010000, t: 'Allow multiple', icon: 'content_copy' },
  { p: 'listado', pad: '            ', mask: 0b001000, t: 'In listing', icon: 'grid_on' },
  { p: 'buscar', pad: '             ', mask: 0b000100, t: 'Allow search', icon: 'search' },
  { p: 'keep_history', pad: '       ', mask: 0b000010, t: 'Keep when delete Record', icon: 'update' },
  { p: 'omit_history_match', mask: 0b000001, t: 'Skip when searching for matches in history', icon: 'layers_clear' },
]

const FLAGS_MASK = pickBy(FLAGS_MASK_LIST, (p) => p.p)

class PanelPreguntasComponentCtrl {
  pregsState = new PregsState()

  filtros: Filtros = {
    filterq: null,
    flags: FLAGS_MASK_LIST.map((def) => ({ def, activo: false })),
    flags_mask: 0b00000000,
    tipo: mapValues(TIPO_F, (t) => ({
      def: t,
      activo: false,
    })),
    tipo_mask: 0b00000000,
  }

  hayFiltros = false

  constructor(
    private $log: ILogService, //
    private NotifService: NotificacionService,
    private $element: JQLite,
    private $timeout: ITimeoutService,
    private $q: IQService,
    private AccesoDatos: AccesoDatos
  ) {}

  $onInit(): void {
    this.$log.info('[PanelPreguntasComponentCtrl] onInit')

    this.refreshQ(false)
  }

  $postLink() {
    this.$timeout((_) => {
      const searchinput = this.$element.find('#searchbox')

      if (searchinput) {
        searchinput[0].focus()
      }
    }, 50)
  }

  refreshQ(delay = true) {
    if (delay) {
      this.pregsState.conPreguntas([])

      this.$timeout(() => this._leerPregs(), 200)
    } else {
      this._leerPregs()
    }
  }

  private _leerPregs() {
    this.$q
      .all([
        //
        this.AccesoDatos.Preg_CLIENT.listaPreguntas(),
        this.AccesoDatos.MainQuestions_CLIENT.todasLasPregPrincipales(),
      ])
      .then(([pregsList, mainPregsList]) => {
        this.pregsState.conPreguntas(pregsList.list.map((p) => new PregState(p)))
        this.pregsState.storeMainQ = new StoreMainQ(mainPregsList)
      })
  }

  sinFiltro() {
    this.filtros.filterq = null

    forEach(this.filtros.flags, (f) => {
      f.activo = false

      return true
    })
    this.filtros.flags_mask = 0b0

    forEach(this.filtros.tipo, (_, key) => {
      this.filtros.tipo[key as ITipoQ].activo = false
    })
    this.filtros.tipo_mask = 0b0

    this.filtrarQ()
  }

  filtroText(t: string) {
    this.filtros.filterq = t

    this.filtrarQ()
  }

  filtrarQ() {
    this.hayFiltros = !!(trim(this.filtros.filterq) || this.filtros.flags_mask || this.filtros.tipo_mask)

    this.pregsState.filtrarPregs(this.filtros)
  }

  filtrarFlag(flag: FiltroFlag) {
    flag.activo = !flag.activo

    this.filtros.flags_mask ^= flag.def.mask

    this.filtrarQ()
  }

  filtrarTipo(flag: FiltroTipo) {
    flag.activo = !flag.activo

    this.filtros.tipo_mask ^= flag.def.mask

    this.filtrarQ()
  }

  nuevaPregunta() {
    this.pregsState.nuevaPreg(new PregState({ data: { subpreg: false } } as IEdicionPregunta))
  }
}

export class StoreMainQ {
  constructor(public list: IModelMainQuestion[]) {}
}

const DEF_TIPO = TIPO_F

export class PregState {
  _search = ''
  _flagsMask = 0b000000
  _tipoMask = 0b0

  constructor(public datapreg: IEdicionPregunta) {
    const _t = `${datapreg.data.texto_en} ${datapreg.data.tipoq} ${datapreg.data.explanation}`

    const _tt = datapreg.subp?.length ? _t + ' ' + datapreg.subp.map((subp) => `${subp.data.texto_en}`).join(' ') : _t

    this._search = lowerCase(deburr(_tt))

    this._flagsMask = this.__flags(datapreg.data)
    this._tipoMask = this.__tipo(datapreg.data)
  }

  private __flags(data: IModelPregunta) {
    // reduce(PROPS_MASK, )

    let _v = 0b000000
    for (const _p of FLAGS_MASK_LIST) {
      _v = _v | (data[_p.p] ? _p.mask : 0)
    }

    return _v
  }

  private __tipo(data: IModelPregunta) {
    if (data.tipoq) {
      const def = DEF_TIPO[data.tipoq as ITipoQ]

      if (def) {
        return def.mask
      }
    }

    return 0b00000
  }

  _matchText(t: string) {
    return this._search.includes(t)
  }

  _matchFlags(mask: number) {
    // return (this._flagsMask & mask) == mask  // cumple todo

    return this._flagsMask & mask // cumple alguno
  }

  _matchTipo(mask: number) {
    return this._tipoMask & mask // cumple alguno
  }
}

export class PregsState {
  list: PregState[] = []
  visibles: PregState[] = []

  storeMainQ: StoreMainQ

  // -----

  conPreguntas(list: PregState[]) {
    this.visibles = this.list = list
  }

  nuevaPreg(p: PregState) {
    this.list.push(p)
    if (this.list !== this.visibles) {
      this.visibles.push(p)
    }
  }

  filtrarPregs(f: Filtros) {
    if (f.filterq || f.flags_mask || f.tipo_mask) {
      const _f = deburr(lowerCase(f.filterq))

      this.visibles = this.list.filter(
        (
          p // //
        ) =>
          (!f || p._matchText(_f)) &&
          (!f.flags_mask || p._matchFlags(f.flags_mask)) &&
          (!f.tipo_mask || p._matchTipo(f.tipo_mask))
      )
    } else {
      this.visibles = this.list
    }
  }
}

angular.module('candidato').component('panelPreguntas', {
  bindings: {},
  controller: PanelPreguntasComponentCtrl,
  template: require('./panel-preguntas.component.html'),
  // templateUrl: './panel-preguntas.component.html',
})
